import { useOutlook } from '../../hooks';
import { SettingsContent } from '../../components/SettingsComponents/SettingsContent';
import { StyledSettingsPage } from './SettingsPage.styles';

const SettingsPage = () => {
    useOutlook();
    return (
        <StyledSettingsPage>
            <SettingsContent />
        </StyledSettingsPage>
    );
};

export default SettingsPage;
